import { useCallback } from "react"
import {
  abi as priceFeedAbi,
  address as priceFeedAddress,
} from "@mezo-org/musd-contracts/deployments/mainnet/PriceFeed.json"
import { address as priceFeedTestnetAddress } from "@mezo-org/musd-contracts/deployments/matsnet/PriceFeed.json"
import { Address } from "viem"
import { useReadContract } from "wagmi"

import { setCollateralPrice, useDappDispatch } from "#/redux-state"
import { IS_MEZO_MAINNET, MEZO_CHAIN } from "#/shared/constants"

const useMusdCollateralPrice = () => {
  const dispatch = useDappDispatch()

  const { refetch: fetchCollateralPriceContractData } = useReadContract({
    chainId: MEZO_CHAIN.id,
    abi: priceFeedAbi,
    address: (IS_MEZO_MAINNET
      ? priceFeedAddress
      : priceFeedTestnetAddress) as Address,
    functionName: "fetchPrice",
  })

  const fetchCollateralPrice = useCallback(async () => {
    const { data } = await fetchCollateralPriceContractData()
    dispatch(setCollateralPrice((data as bigint) ?? null))
  }, [fetchCollateralPriceContractData, dispatch])

  return { fetchCollateralPrice }
}

export default useMusdCollateralPrice
